import clsx from 'clsx';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { CarretArrowDown, TriangleDownFilled } from '../icons';
import styles from './GeoIpSelector.module.scss';
import { useGeoIpSelector } from './useGeoIpSelector';
import { useOutsideClick } from '../../../hooks/useOutsideClick';
import { theme } from './_vars';

const GeoIpSelector = ({
  setLocalItem,
  isInverted = false,
  bordered = false,
}) => {
  const {
    toggleDropdown,
    handleItemClick,
    selectedItem,
    isOpen,
    getCurrentOption,
    getPopupPosition,
    popupPosition,
    setPopupPosition,
  } = useGeoIpSelector();
  const { label: currentLabel } = getCurrentOption();
  const { locale_mapping: items } = useSelector(
    (state) => state.app.context?.project?.data,
  );

  const elementRef = useRef(null);

  useOutsideClick({
    ref: elementRef,
    handler: toggleDropdown,
    activate: isOpen,
  });

  useEffect(() => {
    setPopupPosition(getPopupPosition(elementRef));
  }, [elementRef]);

  const handleClick = (val) => {
    setLocalItem(val);
    handleItemClick(val);
  };

  const customStyles = isOpen
    ? { transform: 'rotate(180deg)', transition: 'all .3s' }
    : { transform: 'rotate(0)' };

  return (
    <div
      ref={elementRef}
      className={clsx(
        styles.countrySelector,
        isInverted && styles.countrySelectorIsInverted,
        bordered && styles.countrySelectorBordered,
      )}
    >
      <div className={styles.countrySelectorHeader} onClick={toggleDropdown}>
        {selectedItem && (
          <span className={styles.countrySelectorLabel}>{currentLabel}</span>
        )}
        <div className={styles.countrySelectorArrow}>
          {theme !== 'Jag' ? (
            <CarretArrowDown height="26" width="26" style={customStyles} />
          ) : (
            <TriangleDownFilled height="10" width="10" style={customStyles} />
          )}
        </div>
      </div>
      <div
        className={clsx(
          styles.countrySelectorBody,
          isOpen && styles.countrySelectorBodyOpen,
          styles[popupPosition],
        )}
      >
        {items &&
          items?.map((item) => (
            <div
              key={item.value}
              className={clsx(
                styles.countrySelectorItem,
                item.value === selectedItem && styles.countrySelectorItemActive,
              )}
              onClick={() => handleClick(item.value)}
            >
              {item.special && (
                <span className={styles.countrySelectorIcon}>
                  {item.special}
                </span>
              )}
              <span className={styles.countrySelectorLabel}>{item.label}</span>
            </div>
          ))
        }
      </div>
    </div>
  );
};

export default GeoIpSelector;
